import { getUploadImgToken } from '@/api/base/imageToken';

const GET_UPLOADIMG_TOKEN = 'GET_UPLOADIMG_TOKEN';
const FETCH_STATE = 'FETCH_STATE';

const state = {
  imgToken: '',
  fetching: false,
};

const getters = {
  imgToken: state => state.imgToken,
};

const actions = {
  getUploadImgToken({ commit }) {
    if (state.fetching) return;
    commit(FETCH_STATE, true);
    return getUploadImgToken().then(res => {
      const { token } = res.data;
      commit(GET_UPLOADIMG_TOKEN, token);
      commit(FETCH_STATE, false);
    });
  },
};

const mutations = {
  [GET_UPLOADIMG_TOKEN](state, data) {
    state.imgToken = data;
  },
  [FETCH_STATE](state, fetching) {
    state.fetching = fetching;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
